import { Component, OnInit } from '@angular/core';
import { SUPPORT_EMAIL } from 'src/app/constants/emailAndLinks';
import { IMAGES } from 'src/app/constants/imagePath';

@Component({
  selector: 'app-cancellation-policy',
  templateUrl: './cancellation-policy.component.html',
  styleUrls: ['./cancellation-policy.component.scss'],
  standalone: false
})
export class CancellationPolicyComponent implements OnInit {
  Images = IMAGES
  constructor() { }
  SupportEmail = SUPPORT_EMAIL;

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'auto' });

  }

}
